import { render, staticRenderFns } from "./UserExperience.vue?vue&type=template&id=227316e0&scoped=true"
import script from "./UserExperience.vue?vue&type=script&lang=ts"
export * from "./UserExperience.vue?vue&type=script&lang=ts"
import style0 from "./UserExperience.vue?vue&type=style&index=0&id=227316e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227316e0",
  null
  
)

export default component.exports